import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { css } from "@emotion/css";
import { Link } from "react-router-dom";
import styles from "./Home.module.scss";
import { getLocalStorage } from "../utils/localStorageClient";
import { fromNow } from "../utils/timeUtil";
import NetworkStateBar from "./NetworkStateBar";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import HomeTopBar from "./HomeTopBar";
import { px2vw as p } from "../utils/cssUtil";
import DefaultSessionItemIcon from "../assets/icons/chat-round-line-svgrepo-com.svg?react";
import { truncateText } from "../utils";
import { useFontSize, type FontSize } from "../context/FontSizeContext";

const SessionItem = ({ session, style, fontSize }: { session: any; style: any; fontSize: FontSize }) => {
  return (
    <li
      style={{
        ...style,
        backgroundColor: "var(--weui-BG-2)",
      }}
      className={css`
        &:first-child::before {
          display: none;
        }
        &:before {
          /* left: 52px; */
          /* left: calc(${p("40px")} + ${p("12px")} + ${p("12px")}) */
          left: calc(40px + 12px + 12px);
        }
        &::before {
          content: " ";
          position: absolute;
          /* left: 0; */
          top: 0;
          right: 0;
          height: 1px;
          border-top: 1px solid var(--weui-FG-3);
          color: var(--weui-FG-0);
          -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
          /* left: 16px; */
          z-index: 2;
        }
      `}
    >
      <Link to={`/s/${session.id}`} className={styles.messageItem}>
        <div className={styles.avatar}>
          {/* <img
            src="https://g-prjni2qbtcn.vusercontent.net/placeholder.svg"
            alt="Profile"
          /> */}
          <DefaultSessionItemIcon />
        </div>
        <div className={styles.messageRight}>
          <div className={styles.messageContent}>
            <h3 className={clsx(styles.messageSender, styles.ellipsisHidden)} style={{ fontSize: `${14 + fontSize}px` }}>
              {session.lastApp?.name ?? ""}
            </h3>
            <p className={clsx(styles.messageText, styles.ellipsisHidden)} style={{ fontSize: `${12 + fontSize}px` }}>
              {truncateText(session.topic ?? "", 30)}
            </p>
          </div>
          <span className={styles.messageTime}>
            {fromNow(session.updatedTime || session.createdTime)}
          </span>
          {/* <span className={styles.messageDivider}></span> */}
        </div>
      </Link>
    </li>
  );
};

function Home({ config }: { config: any | null }) {
  const [assistantName, setAssistantName] = useState<string | null>(null);
  const [networkStateBarShow, setNetworkStateBarShow] = useState(false);
  const { fontSize } = useFontSize();
  useEffect(() => {
    if (config) {
      setAssistantName(config.name);
    }
  }, [config]);
  // const networkStateBarHeight = `calc(100% - ${p(42 + 6 * 2)}vw - ${
  //   networkStateBarShow ? p("48px") : "0vw"
  // })`;
  const networkStateBarHeight = `calc(100% - ${42 + 6 * 2}px - ${
    networkStateBarShow ? "48px" : "0px"
  })`;
  console.log("networkStateBarHeight", networkStateBarHeight);

  return (
    <>
      <HomeTopBar title={`${assistantName}(${config && config.sessions && config.sessions.length})`} />
      <NetworkStateBar
        onShow={() => setNetworkStateBarShow(true)}
        onClose={() => setNetworkStateBarShow(false)}
      />
      <div
        className={styles.container}
        style={{
          height: networkStateBarHeight,
        }}
      >
        {config && config.sessions && config.sessions.length > 0 && (
          // <ol className={styles.messageList}>
          //   {config.sessions.map((session: any) => (
          //     <SessionItem key={session.id} session={session} />
          //   ))}
          // </ol>
          <ol className={styles.messageList}>
            <AutoSizer>
              {({ height, width }) => (
                <List
                  height={height}
                  width={width}
                  itemCount={config.sessions.length}
                  itemSize={76}
                >
                  {({ index, style }) => (
                    <>
                      <SessionItem
                        session={config.sessions[index]}
                        style={style}
                        fontSize={fontSize}
                      />
                    </>
                  )}
                </List>
              )}
            </AutoSizer>
          </ol>
        )}
      </div>
    </>
  );
}

export default Home;
